export default function Category() {
  return (
    <div>
      <button type="button">Check status</button>
    </div>
  );
}
